"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/PlaidImportModal/PlaidInstitutionRebindDialog";

import React from "react";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

export interface PlaidInstitutionRebindDialogProps {
  onCancel: () => void;
  onAdd: () => void;
}

export const PlaidInstitutionRebindDialog: React.FC<
  PlaidInstitutionRebindDialogProps
> = ({ onCancel, onAdd }) => {
  return (
    <div
      className="absolute inset-0 z-10 flex items-center justify-center bg-[#111112]/16 px-4"
      data-testid="plaid-institution-rebind-dialog"
      role="dialog"
      aria-labelledby="plaid-rebind-title"
      aria-describedby="plaid-rebind-description"
    >
      <div
        className={cn(
          "w-full max-w-sm rounded-2xl bg-background_solid_secondary p-6",
          "flex flex-col gap-6 shadow-lg",
        )}
      >
        <div className="flex flex-col gap-2">
          <h2
            id="plaid-rebind-title"
            className="headline_regular_s text-content_primary"
          >
            {I18n.t("The institution is already connected")}
          </h2>
          <p
            id="plaid-rebind-description"
            className="body_m text-content_secondary"
          >
            {`Want to add another account here? I'll keep it under it.`}
          </p>
        </div>
        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            className="secondary_button sm_button button_m text-content_primary min-w-[80px]"
            data-testid="plaid-rebind-cancel"
            onClick={onCancel}
          >
            {I18n.t("Cancel")}
          </button>
          <button
            type="button"
            className="primary_button sm_button button_m min-w-[80px]"
            data-testid="plaid-rebind-add"
            onClick={onAdd}
          >
            {I18n.t("Add")}
          </button>
        </div>
      </div>
    </div>
  );
};
